import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { environment } from '@environments/environment';
import { CASINO_CONFIG } from '@components/casino/casino.config';
import { CasinoHelper } from '@components/casino/casino.helper';
import { CasinoGameModel } from '@components/casino/casino.model';

@Component({
  selector: 'slider-component',
  styleUrls: ['./casino.sass'],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './slider.component.html',
})
export class SliderComponent {
  @Input() items = [];
  @Input() itemsPerPage = 10;
  @Input() providerName = '';
  @Input() pageName = 'lobby';
  @Input() isSliderMenu = false;
  currentIndex = 0;
  @Output() sliderMenuAction: EventEmitter<number> = new EventEmitter<number>();
  constructor(private _CasinoHelper: CasinoHelper) {}

  next() {
    const nextIndex = this.currentIndex + this.itemsPerPage;
    if (nextIndex < this.items.length) {
      this.currentIndex = nextIndex;
    }
  }

  prev() {
    const prevIndex = this.currentIndex - this.itemsPerPage;
    if (prevIndex >= 0) {
      this.currentIndex = prevIndex;
    }
  }

  upDownButtonAction() {
    this.sliderMenuAction.emit();
  }

  goGamesMobilAction(item: CasinoGameModel) {
    if (window.innerWidth < CASINO_CONFIG.mobileVersionWidth) {
      this._CasinoHelper.goGamesAction(item);
    }
  }

  protected readonly environment = environment;
}
